import React from "react"

const Dummy = (props) => {
    return <div>{DjangIO.app.grassroots.types.GrassrootsWidgetType.by_value(props.widgetType).label}</div>
}

export default Dummy
